module.exports = __webpack_public_path__ + "static/media/flow-monitor-offline.81dddd89.svg";